import classcat from "classcat";
import React from "react";

import { IconGlobe } from "@touchtech/web-baselayer-ui";

import css from "./LanguageAndCountryButton.module.css";
import useManageLanguageAndCountryButton from "./hooks/useManageLanguageAndCountryButton";

type Props = {
  primary?: boolean;
  onClick: () => void;
};

const LanguageAndCountryButton = ({ primary, onClick }: Props) => {
  const { selectedLanguageCode, selectedCountryCode } =
    useManageLanguageAndCountryButton();

  return (
    <div>
      <button
        className={classcat([
          css.languageSwitchButton,
          { [css.primaryButton]: primary },
        ])}
        onClick={onClick}
      >
        <IconGlobe className={classcat(["text-label-2xl", css.icon])} />
        {`${selectedLanguageCode} ${
          selectedCountryCode && `| ${selectedCountryCode}`
        }`}
      </button>
    </div>
  );
};

export default LanguageAndCountryButton;
